export const numberFormat = (value, currency = 'INR') => {
    if (value == null || isNaN(value)) return '';
    return new Intl.NumberFormat('en-IN', {
        style: currency ? 'currency' : 'decimal',
        currency: currency || undefined,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value).replace('₹', '₹ ');
};